import { createStore } from 'redux'
import { useSelector } from 'react-redux'

// Global state is deliberately tiny: the selected content modules (shared by
// the header picker and every feature page) and the sidebar toggle. Everything
// else is local component state or localStorage. Action creators and selectors
// live here so call sites don't hand-write action objects.

// "All modules available to this user" - the backend's wildcard data asset.
export const ALL_MODULES = '*'

const initialState = {
  sidebarShow: false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)

export const setSelectedIndex = (selectedIndex) => ({ type: 'set', selectedIndex })
export const selectAllModules = () => setSelectedIndex(ALL_MODULES)
export const setSidebarShow = (sidebarShow) => ({ type: 'set', sidebarShow })

export const selectSelectedIndex = (state) => state.selectedIndex
export const selectSidebarShow = (state) => state.sidebarShow

// True once the user has picked at least one content module.
export const isModuleSelected = (selectedIndex) =>
  selectedIndex !== undefined && selectedIndex !== ''

export const useSelectedIndex = () => useSelector(selectSelectedIndex)
export const useSidebarShow = () => useSelector(selectSidebarShow)

export default store
